import { Payload, Types } from 'states/dux/layout/types'
import { Action } from 'states/types'

const set = (payload: Payload): Action<Payload> => {
  return {
    type: Types.SET,
    payload
  }
}

const update = (payload: Partial<Payload>): Action<Payload> => {
  return {
    type: Types.UPDATE,
    payload: payload as Payload
  }
}

export { set, update }
